import { render } from "./portraits-question.vue?vue&type=template&id=28495e0d&scoped=true"
import script from "./portraits-question.vue?vue&type=script&lang=js"
export * from "./portraits-question.vue?vue&type=script&lang=js"

import "./portraits-question.vue?vue&type=style&index=0&id=28495e0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28495e0d"]])

export default __exports__